import styled, { keyframes } from 'styled-components';
import { Box, themedColor } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';

const BASE_MOCK_DURATION = 1000;

const Container = styled(Box)`
  position: relative;
  will-change: contents;

  ${MEDIA_QUERIES.upToDesktop`
        transform: scale(0.5) translateX(-75px);
    `}
`;

const Pipe = styled(Box)`
  background-color: ${themedColor('glass')};
  border-radius: 50px;
  position: absolute;
  z-index: -1;
  animation-play-state: paused;
  animation-duration: ${BASE_MOCK_DURATION}ms;
  width: 100px;
  height: 100px;
  animation-timing-function: ease-out;
`;

const StallPipe = styled(Pipe)`
  opacity: 0.2;
  background-color: ${themedColor('primary')} !important;
`;

const pipeOneAnimation = keyframes`
    0% { transform: scale(0); }
    40% { transform: scale(1); }
    50% { transform: scale(1); height: 100px; }
    70% { height: 227px; }
    100% { height: 227px; }
`;

const circleTwoAnimation = keyframes`
    0% { transform: scale(0); }
    40% { transform: scale(1); }
`;

const pipeTwoAnimation = keyframes`
    0% { transform: scale(0); }
    30% { transform: scale(0); }
    60% { transform: scale(1); }
    80% { transform: scale(1); height: 100px; }
    100% { height: 329px; }
`;

const pipeThreeAnimation = keyframes`
    0% { transform: scale(0); }
    40% { transform: scale(1); }
    60% { transform: scale(1); height: 100px; }
    80% { height: 168px; }
    100% { height: 168px; }
`;

const circleThreeAnimation = keyframes`
    0% { transform: scale(0); }
    60% { transform: scale(0); }
    75% { transform: scale(1); }
`;

const PipeOne = styled(Pipe)`
  animation-name: ${pipeOneAnimation};
`;

const CircleTwo = styled(Pipe)`
  animation-name: ${circleTwoAnimation};
`;

const PipeTwo = styled(Pipe)`
  animation-name: ${pipeTwoAnimation};
`;

const PipeThree = styled(Pipe)`
  animation-name: ${pipeThreeAnimation};
`;

const CircleThree = styled(Pipe)`
  animation-name: ${circleThreeAnimation};
`;

export default function Giveback2020Families({ t, ...props }) {
  const style = { animationDelay: `${-t * (BASE_MOCK_DURATION - 1)}ms` };
  return (
    <Container {...props}>
      <PipeOne top={[210, 210, 210]} left={[0, 0, 0]} style={style} />
      {t === 1 && <StallPipe top={[103, 103, 103]} left={[0, 0, 0]} style={style} />}
      <PipeTwo top={[108, 108, 108]} left={[114, 114, 114]} style={style} />
      <CircleTwo top={['-1px', '-1px', '-1px']} left={[114, 114, 114]} style={style} />
      <PipeThree top={[269, 269, 269]} left={[228, 228, 228]} style={style} />
      <CircleThree top={[161, 161, 161]} left={[228, 228, 228]} style={style} />
    </Container>
  );
}
